const STORAGE_KEY = 'campaign-data';
const UNAUTH_CHECKOUT_KEY = 'unAuthUserCampaign';

export const APP_CAMPAIGN_VISITED_KEY = 'app-campaign-visited-steps';

export const APP_CAMPAIGN_STEP_ROUTES = {
  song: '/create-campaign/add-track',
  campaign: '/create-campaign/set-budget-duration',
  checkout: '/create-campaign/review-campaign',
};

const WIZARD_STEP_ORDER = ['song', 'campaign', 'checkout'];

/** Infer furthest wizard step from persisted draft fields (matches SetBudget restore rules). */
export function inferCampaignDraftStep(draft) {
  if (!draft?.track_name) return 'song';
  if (draft.estimatedStreams != null) return 'checkout';
  return 'campaign';
}

export function visitedStepsForCampaignStep(step) {
  const index = WIZARD_STEP_ORDER.indexOf(step);
  const end = index >= 0 ? index + 1 : 1;
  return WIZARD_STEP_ORDER.slice(0, end);
}

export function persistCampaignVisitedSteps(step) {
  sessionStorage.setItem(APP_CAMPAIGN_VISITED_KEY, JSON.stringify(visitedStepsForCampaignStep(step)));
}

export function getCampaignDraftResumePath(draft) {
  const step = inferCampaignDraftStep(draft);
  persistCampaignVisitedSteps(step);
  return APP_CAMPAIGN_STEP_ROUTES[step];
}

function readJsonStorage(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function readCampaignDraft() {
  return readJsonStorage(STORAGE_KEY);
}

export function writeCampaignDraft(draft) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(draft));
  return draft;
}

export function clearCampaignDraft() {
  localStorage.removeItem(STORAGE_KEY);
}

/** Persist draft before Stripe redirect; optionally mirror for post-login callback. */
export function writeCheckoutSnapshot(draft, { mirrorForAuthCallback = false } = {}) {
  writeCampaignDraft(draft);
  if (mirrorForAuthCallback) {
    localStorage.setItem(UNAUTH_CHECKOUT_KEY, JSON.stringify(draft));
  }
  return draft;
}

export function mergeCheckoutSnapshot(partial) {
  const current = readCampaignDraft() || readJsonStorage(UNAUTH_CHECKOUT_KEY) || {};
  const merged = { ...current, ...partial };
  writeCampaignDraft(merged);
  if (readJsonStorage(UNAUTH_CHECKOUT_KEY)) {
    localStorage.setItem(UNAUTH_CHECKOUT_KEY, JSON.stringify(merged));
  }
  return merged;
}

export function readPendingCheckoutSnapshot() {
  return readCampaignDraft() || readJsonStorage(UNAUTH_CHECKOUT_KEY);
}

export function clearCheckoutSnapshot() {
  clearCampaignDraft();
  localStorage.removeItem(UNAUTH_CHECKOUT_KEY);
}
